__turbopack_context__.v({
  "buttonWrapper": "dvgDfW_buttonWrapper",
  "chevronIcon": "dvgDfW_chevronIcon",
  "closeButton": "dvgDfW_closeButton",
  "collapsibleContent": "dvgDfW_collapsibleContent",
  "collapsibleInner": "dvgDfW_collapsibleInner",
  "descriptionSection": "dvgDfW_descriptionSection",
  "descriptionText": "dvgDfW_descriptionText",
  "detailItem": "dvgDfW_detailItem",
  "detailItemDescription": "dvgDfW_detailItemDescription",
  "detailItemTitle": "dvgDfW_detailItemTitle",
  "detailsList": "dvgDfW_detailsList",
  "divider": "dvgDfW_divider",
  "footerButton": "dvgDfW_footerButton",
  "footerButtonLabel": "dvgDfW_footerButtonLabel",
  "headerCurrentPrice": "dvgDfW_headerCurrentPrice",
  "headerInfo": "dvgDfW_headerInfo",
  "headerOriginalPrice": "dvgDfW_headerOriginalPrice",
  "headerPerMonth": "dvgDfW_headerPerMonth",
  "headerPriceRow": "dvgDfW_headerPriceRow",
  "headerSection": "dvgDfW_headerSection",
  "modalContainer": "dvgDfW_modalContainer",
  "modalContent": "dvgDfW_modalContent",
  "planName": "dvgDfW_planName",
  "sectionHeader": "dvgDfW_sectionHeader",
  "sectionTitle": "dvgDfW_sectionTitle",
  "stickyFooter": "dvgDfW_stickyFooter",
  "thumbnailContainer": "dvgDfW_thumbnailContainer",
  "tooltip": "dvgDfW_tooltip",
});
